import { library } from '@fortawesome/fontawesome-svg-core'
import { faWhatsapp, faFacebook } from '@fortawesome/free-brands-svg-icons'
import {
  faSquare,
  faSquareCheck,
  faEnvelope as farEnvelope,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faCakeCandles,
  faCalendar,
  faPen,
  faCalendarPlus,
  faCashRegister,
  faCheck,
  faCheckDouble,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleInfo,
  faEarthEurope,
  faEllipsisV,
  faGripLines,
  faHome,
  faLockKeyhole,
  faPhoneVolume,
  faUserFriends,
  faMegaphone,
  faXmark,
  faGem,
  faCalendarCircleMinus,
  faCalendarCirclePlus,
  faCalendarClock,
  faMagnifyingGlass,
  faCirclePlus,
  faLockKeyholeOpen,
  faTrash,
  faUser,
  faCalendarDay,
  faCircleXmark,
  faClock,
  faCog,
  faCaretLeft,
  faCaretRight,
  faArrowToLeft,
  faArrowLeft,
  faTimes,
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faTimesCircle,
  faPlus,
  faPlusCircle,
  faNote,
  faPrint,
  faClone,
  faScissors,
  faEuroSign,
  faBan,
  faCircleMinus,
  faCircleExclamation,
  faCircleX,
  faCircleDollar,
  faCircleCheck,
  faCircleEllipsis,
  faCaretUp,
  faCaretDown,
  faCartCircleExclamation,
  faBars,
  faArrowRightFromBracket,
  faMessagePlus,
  faEnvelope as fasEnvelope,
  faRoute,
  faStar,
  faCircle,
  faAt,
  faMessageSms,
  faRectangleAd,
  faUsers,
  faUserGroup,
  faArrowRotateRight,
  faEllipsisVertical,
  faSquareMinus,
  faFolder,
  faTag,
  faOctagonExclamation,
  faEnvelopeOpen,
  faCopy,
  faTriangleExclamation,
  faSpinnerThird,
  faCross,
  faCalendarExclamation,
  faIslandTropical,
  faCoffee,
  faArrowRight,
  faTrashUndo,
  faFilter,
  faCirclePlay,
  faEye,
} from '@fortawesome/pro-solid-svg-icons'
library.add(
  faGripLines,
  faEarthEurope,
  faPen,
  faLockKeyhole,
  faCakeCandles,
  faCircleInfo,
  faCheck,
  faCheckDouble,
  faXmark,
  faHome,
  faCalendar,
  faUserFriends,
  faMegaphone,
  faPhoneVolume,
  faCalendarPlus,
  faCashRegister,
  faEllipsisV,
  faChevronDown,
  faChevronLeft,
  faChevronDoubleLeft,
  faChevronRight,
  faChevronDoubleRight,
  faGem,
  faCalendarCircleMinus,
  faCalendarCirclePlus,
  faCalendarClock,
  faMagnifyingGlass,
  faCirclePlus,
  faLockKeyholeOpen,
  faTrash,
  faUser,
  faCalendarDay,
  faCircleXmark,
  faClock,
  faCog,
  faCaretLeft,
  faCaretRight,
  faArrowToLeft,
  faArrowLeft,
  faTimes,
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faTimesCircle,
  faPlus,
  faPlusCircle,
  faCircleInfo,
  faNote,
  faPrint,
  faClone,
  faScissors,
  faEuroSign,
  faBan,
  faCircleMinus,
  faCircleExclamation,
  faCircleX,
  faCircleDollar,
  faCircleCheck,
  faCircleEllipsis,
  faCaretUp,
  faCaretDown,
  faCartCircleExclamation,
  faBars,
  faArrowRightFromBracket,
  faMessagePlus,
  fasEnvelope,
  farEnvelope,
  faRoute,
  faStar,
  faCircle,
  faAt,
  faMessageSms,
  faRectangleAd,
  faUsers,
  faUserGroup,
  faSquare,
  faSquareCheck,
  faArrowRotateRight,
  faEllipsisVertical,
  faSquareMinus,
  faFolder,
  faTag,
  faOctagonExclamation,
  faEnvelopeOpen,
  faCopy,
  faArrowRightFromBracket,
  faTriangleExclamation,
  faSpinnerThird,
  faCross,
  faWhatsapp,
  faFacebook,
  faCalendarExclamation,
  faIslandTropical,
  faCoffee,
  faArrowRight,
  faTrashUndo,
  faFilter,
  faCirclePlay,
  faEye,
)
